import React, { useMemo } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { Grid, Typography } from '@mui/material_modern'
import DispatchActiveTicketsLoadBoardItem from 'components/containers/load-board/components/DispatchActiveTicketsLoadBoardItem.jsx'
import PropTypes from 'prop-types'
import { useContentHeight } from 'utils/custom-hooks/useContentHeight'
import { Tooltip } from '@mui/material'
// Style for when the column is shared by two draggables
const withPastDraggableStyling = {
  background: 'background.default',
  minWidth: '200px',
  maxWidth: '250px',
  minHeight: '80px',
}

// Style for the full column
const withoutPastDraggableStyling = {
  background: 'background.default',
  minWidth: '200px',
  maxWidth: '250px',
  minHeight: '440px',
  overflowY: 'auto',
}

const DispatchActiveTicketsLoadBoardColumn = ({ droppableId, driverInfo, currentTickets, pastTickets }) => {
  // Adjusts the styling of the present draggable if there are no past tickets
  const draggableStyling = useMemo(() => {
    return pastTickets?.length > 0 ? withPastDraggableStyling : withoutPastDraggableStyling
  }, [pastTickets])
  const { dispatchActiveTicketsContentHeight } = useContentHeight()

  return (
    <Grid p={1}>
      <Typography
        pb={2}
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: '100%', // Adjust as needed
        }}
      >
        {driverInfo?.name === 'Requested Tickets' ? (
          <Tooltip title="Requested tickets are created by users in the supplier portal" placement="right">
            <span>{driverInfo?.name}</span>
          </Tooltip>
        ) : (
          driverInfo?.name
        )}
      </Typography>
      <div style={{ ...withoutPastDraggableStyling, height: dispatchActiveTicketsContentHeight }}>
        {pastTickets?.length > 0 ? (
          <>
            <Droppable droppableId={droppableId + 'past'}>
              {/* {(provided, snapshot) => ( */}
              {provided => (
                <div ref={provided.innerRef} style={withPastDraggableStyling}>
                  {pastTickets.map((item, index) => {
                    return <DispatchActiveTicketsLoadBoardItem key={item.id} item={item} index={index} />
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </>
        ) : null}
        {pastTickets?.length > 0 && currentTickets?.length > 0 ? (
          <Typography
            variant="body2"
            pt={1}
            pb={1}
            style={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              width: '100%', // Adjust as needed
            }}
          >
            Scheduled for Today:
          </Typography>
        ) : null}
        <Droppable droppableId={droppableId}>
          {/* {(provided, snapshot) => ( */}
          {provided => (
            <div ref={provided.innerRef} style={draggableStyling}>
              {currentTickets.map((item, index) => {
                return <DispatchActiveTicketsLoadBoardItem key={item.id} item={item} index={index} />
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </Grid>
  )
}

DispatchActiveTicketsLoadBoardColumn.propTypes = {
  droppableId: PropTypes.string.isRequired,
  driverInfo: PropTypes.object,
  currentTickets: PropTypes.array.isRequired,
  pastTickets: PropTypes.array.isRequired,
}

DispatchActiveTicketsLoadBoardColumn.defaultProps = {
  driverInfo: {},
  currentTickets: [],
  pastTickets: [],
}

export default DispatchActiveTicketsLoadBoardColumn
